import { render, staticRenderFns } from "./DeductionDialog.vue?vue&type=template&id=701f2847"
import script from "./DeductionDialog.vue?vue&type=script&lang=js"
export * from "./DeductionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports